import { useEffect } from 'react'

import Loading from 'components/Loading'
import MovieCard from 'components/MovieCard'
import Title from 'components/Title'

import { useMoviesContext } from 'contexts/MoviesContext'

interface MoviesContainerProps {
  title: string
  filter: string
}

const MoviesContainer = ({ title, filter }: MoviesContainerProps) => {
  const { moviesData, isLoading, fetchMovies } = useMoviesContext()

  useEffect(() => {
    fetchMovies(filter)
  }, [filter])

  const movies = moviesData[filter] || []

  return (
    <section className="movies-page">
      <div className="container">
        {isLoading ? (
          <Loading text="Carregando filmes..." />
        ) : (
          <>
            <Title>{title}</Title>
            {movies.length > 0 && (
              <section className="movies">
                {movies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </section>
            )}
          </>
        )}
      </div>
    </section>
  )
}

export default MoviesContainer
